import { lazy } from "react";

import { isAtlasClient } from "../helpers/clientUtils";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  "login-id": lazy(() => import("@/screens/login-id")),
  login: lazy(() => import("@/screens/login")),
  "login-password": lazy(() => import("@/screens/login-password")),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-request": lazy(
    () => import("@/screens/reset-password-request")
  ),
  "reset-password-email": lazy(() => import("@/screens/reset-password-email")),
  "reset-password-success": lazy(
    () => import("@/screens/reset-password-success")
  ),
  signup: lazy(() => import("@/screens/signup")),
};

// Atlas-specific screen variants
const ATLAS_SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  login: lazy(() => import("@/screens/login-atlas")),
  signup: lazy(() => import("@/screens/signup-atlas")),
  "reset-password-success": lazy(
    () => import("@/screens/reset-password-success-atlas")
  ),
  "reset-password-request": lazy(
    () => import("@/screens/reset-password-request-atlas")
  ),
};

export const getScreenComponent = (
  screenName: string
): React.ComponentType | null => {
  // Check if Atlas client and has a specific variant
  if (isAtlasClient()) {
    const atlasComponent = ATLAS_SCREEN_COMPONENTS[screenName];
    if (atlasComponent) {
      return atlasComponent;
    }
  }

  // Fall back to default screen
  return SCREEN_COMPONENTS[screenName] || null;
};
